import { render } from "./ShowTrend.vue?vue&type=template&id=16b18e36&scoped=true"
import script from "./ShowTrend.vue?vue&type=script&lang=js"
export * from "./ShowTrend.vue?vue&type=script&lang=js"

import "./ShowTrend.vue?vue&type=style&index=0&id=16b18e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b18e36"]])

export default __exports__